module.exports = __webpack_public_path__ + "img/pink_student.54da3abe.gif";